const HeaderBurgerMenu = () => {
  const body = document.body;
  const opener = document.querySelector(".header__burger-menu-opener");
  const menu = document.querySelector(".header__nav");

  const searchWrapper = document.querySelector(".header__search-wrapper");
  const searchResults = document.querySelector(".header__search-results");
  const form = document.querySelector(".header__search-form");
  const input = form.querySelector(".header__search-input");

  if (opener) {
    opener.addEventListener("click", () => {
      body.classList.toggle("no-scroll");
      menu.classList.toggle("opened");
      opener.classList.toggle("opened");
      searchWrapper.classList.remove("opened");
      searchResults.classList.remove("opened");
      input.value = "";
    })
  }
}

export default HeaderBurgerMenu